<template>
  <div class="head-one">
    <div class="head-top-box">
      <div class="head-logo">
        <!-- <img class="icon-logo" src="@/assets/image/common/logo.png" @click="onHome" alt=""> -->
        <img class="icon-logo" :src="userInfoObj.isRule == 1?'/static/img/common/logo-list.png':'/static/img/common/logo-list.png'" @click="onHome" alt="">
        <!-- <p class="head-title" @click="onView">评审文书</p> -->
        <!-- <div class="version-box">专业版</div> -->
      </div>
      <div class="head-con">
        <nav class="tab-item" :class="item.id == active ? 'active' : ''" v-for="item in tabList" :key="item.id">
          <div v-if="item.type == 1" @click="onOpen(item)">{{ item.name }}</div>
          <div class="item-relative" v-else-if="item.type == 2">
            {{ item.name }}
            <span class="trangle"></span>
            <div class="absolut-o">
              <div class="a-o-item" v-for="val in item.children" :key="val.id" @click="onOpen(val)">{{ val.name }}</div>
            </div>
          </div>
          <div class="item-relative" v-else-if="item.type == 3">
            {{ item.name }}
            <span class="trangle"></span>
            <div class="absolut-t">
              <div class="a-t-box">
                <div class="a-t-item" v-for="row in item.children" :key="row.id">
                  <div class="a-t-item-titlt">
                    <img class="icon-item" :src="row.icon" alt="">
                    <span>{{ row.name }}</span>
                  </div>
                  <div class="title-border"></div>
                  <div class="a-t-item-name" v-for="(rowItem, index) in row.children" :key="rowItem.id"
                    :style="{ 'margin-top': index == 0 ? '16px' : '' }" @click="onOpen(rowItem)">{{
                      rowItem.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="head-user">
        <el-avatar :size="24" v-if="info.avtar" :src="info.avtar.indexOf('http') > -1 ? info.avtar : filesPrefix + info.avtar"></el-avatar>
        <el-avatar :size="24" v-else src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
        <div class="user-name">{{ info.userName }}</div>
        <div class="user-set">
          <!-- <div class="user-set-item">
            <a class="icon-grzx" :href="urlPrefix + '/home/index'">个人中心</a>
          </div>
          <div class="user-set-item">
            <a class="icon-pt" :href="urlPrefix + '/partner-center/index'">切换为合伙人</a>
          </div>
          <div class="lines"></div> -->
          <div class="user-set-item">
            <a class="icon-grxx" :href="urlPrefix + '/personal-setting'">个人信息</a>
          </div>
          <div class="user-set-item">
            <a class="icon-zhaq" :href="urlPrefix + '/personal-setting/account-security'">账户安全</a>
          </div>
          <div class="lines"></div>
          <div class="user-set-item" @click="loginOut">
            <img src="@/assets/image/common/icon-tcdl.png" alt />
            <p>退出登录</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box globalScrool">
      <router-view></router-view>
    </div>
    <warning ref="warning"></warning>
  </div>
</template>
<script>
import _tools from "@/framework/common/qds_tools";
import warning from "./plugin/warning";
const userInfo = _tools.getCookie('QDS_LOGIN_INFO');
export default {
  components: { 'warning': warning },
  data() {
    return {
      userInfoObj: userInfo ? JSON.parse(decodeURIComponent(userInfo)) : {},
      tabList: [
        // type: 1 不做循环处理  2 单循环  3 组合式循环
        // routeType: 1 本项目内打开  2 外部项目打开
        { name: "文字商标", id: 11, type: 1, router: 'so.quandashi.com/brandSearchIndex', routerPartner: 'so.quandashi.com/brandSearchIndex', routerNormal: 'so.quandashi.com/brandSearchIndex', routeType: 2 },
        { name: "图形商标", id: 12, type: 1, router: 'so.quandashi.com/brandSearchFigure', routerPartner: 'so.quandashi.com/brandSearchFigure', routerNormal: 'so.quandashi.com/brandSearchFigure', routeType: 2 },
        { name: "商标对比", id: 21, type: 1, router: 'so.quandashi.com/goodsCompare', routerPartner: 'so.quandashi.com/goodsCompare', routerNormal: '', routeType: 2 },
        { name: "评审文书", id: 13, type: 1, router: 'review.quandashi.com/list', routerPartner: 'review.quandashi.com/list', routerNormal: '', routeType: 2 },
        // { name: "初审公告", id: 18, type: 1, router: 'so.quandashi.com/search/notice/index', routerPartner: 'so.quandashi.com/search/notice/index', routerNormal: 'so.quandashi.com/search/notice/index', routeType: 2 },
        { name: "商标公告", id: 14, type: 1, router: 'gonggao.quandashi.com/#/trademarkDetail', routerPartner: 'gonggao.quandashi.com/#/trademarkDetail', routerNormal: 'gonggao.quandashi.com/#/trademarkDetail', routeType: 2 },
        { name: "商品分类", id: 15, type: 1, router: 'so.quandashi.com/goodsClassify', routerPartner: 'so.quandashi.com/goodsClassify', routerNormal: 'so.quandashi.com/goodsClassify', routeType: 2 },
        { name: "批量搜索", id: 22, type: 1, router: 'so.quandashi.com/mutliSearch/regSearch', routerPartner: 'so.quandashi.com/mutliSearch/regSearch', routerNormal: '', routeType: 2 },
        { name: "境外监测", id: 23, type: 1, router: 'so.quandashi.com/overseas/monitor', routerPartner: 'so.quandashi.com/overseas/monitor', routerNormal: '', routeType: 2 },
        {
          name: "商标监控",
          id: 16,
          type: 2,
          children: [
            { name: "商标监测", id: 161, router: 'www.quandashi.com/brand-monitor/index?tabType=2', routerPartner: 'hhr.quandashi.com/new-brand-monitor?path=https://cmonitor.quandashi.com/monitor/brandnameList', routerNormal: 'www.quandashi.com/brand-monitor/index?tabType=2', routeType: 2 },
            { name: "申请人监测", id: 162, router: 'www.quandashi.com/brand-monitor/index', routerPartner: 'hhr.quandashi.com/new-brand-monitor?path=https://cmonitor.quandashi.com/monitor/applicantList', routerNormal: 'www.quandashi.com/brand-monitor/index', routeType: 2 },
            { name: "代理机构监测", id: 163, router: 'www.quandashi.com/brand-monitor/index', routerPartner: 'hhr.quandashi.com/new-brand-monitor?path=https://cmonitor.quandashi.com/monitor/agencyList', routerNormal: '', routeType: 2 },
          ],
        }, {
          name: "工具服务",
          id: 17,
          type: 3,
          children: [
            {
              name: "专项搜索", id: 171, icon: require('@/assets/image/common/icon-search.png'), children: [
                { name: "驰著名商标", id: 1712, router: 'so.quandashi.com/brandSearchIndex', routerPartner: 'so.quandashi.com/hhr/search?key=&param=2', routerNormal: 'so.quandashi.com/index/search?param=2', routeType: 2 },
                { name: "地理标志", id: 1713, router: 'so.quandashi.com/brandSearchIndex', routerPartner: 'so.quandashi.com/hhr/search?key=&param=2', routerNormal: 'so.quandashi.com/index/search?param=2', routeType: 3 },
              ]
            },
            {
              name: "数据分析", id: 172, icon: require("@/assets/image/common/icon-data.png"), children: [
                { name: "企业分析报告", id: 1721, router: 'hhr.quandashi.com/brand-monitor-task?activeName=%E7%94%B3%E8%AF%B7%E4%BA%BA', routerPartner: 'hhr.quandashi.com/brand-monitor-task?activeName=%E7%94%B3%E8%AF%B7%E4%BA%BA&analysisReportVisible=true', routerNormal: '', routeType: 2 },
                { name: "同行竞争对比", id: 1722, router: 'hhr.quandashi.com/brand-monitor-task?activeName=%E7%94%B3%E8%AF%B7%E4%BA%BA', routerPartner: 'hhr.quandashi.com/brand-monitor-task?activeName=%E7%94%B3%E8%AF%B7%E4%BA%BA', routerNormal: '', routeType: 2 },
                { name: "商标大数据", id: 1723, router: 'www.quandashi.com/bi-report/index', routerPartner: 'www.quandashi.com/bi-report/index', routerNormal: 'www.quandashi.com/bi-report/index', routeType: 2 },
              ]
            },
            {
              name: "其他工具", id: 173, icon: require("@/assets/image/common/icon-tool.png"), children: [
                { name: "商标起名", id: 1731, router: 'qm.quandashi.com', routerPartner: 'qm.quandashi.com', routerNormal: '', routeType: 2 },
                { name: "商标公证", id: 1732, router: 'www.quandashi.com/index/download-app', routerPartner: 'www.quandashi.com/index/download-app', routerNormal: 'www.quandashi.com/index/download-app', routeType: 2 },
                { name: "客户线索", id: 1733, router: 'www.quandashi.com/customer-clue/near-by', routerPartner: 'www.quandashi.com/customer-clue/near-by', routerNormal: '', routeType: 2 },
              ]
            },
          ],
        },
      ],
      imgUrl: require('../../assets/image/common/icon-search.png'),
      active: 13,
      urlPrefix: "",
      filesPrefix: "https://files.quandashi.com/",
      info: {},
    };
  },

  mounted() {
    let self = this;
    self.urlPrefix = process.env.LOGIN_UPLOAD;
  },

  created() {
    let info_data = _tools.getCookie("QDS_LOGIN_INFO");
    this.info = info_data && JSON.parse(decodeURIComponent(info_data));
  },

  methods: {
    // 首页
    onHome() {
      let self = this;
      let url = process.env.LOGIN_UPLOAD;
      window.open(url, "_black");
    },
    // 评审文书
    onView() {
      this.$router.push("/index");
    },
    // 打开外部链接
    onOpen(row) {
      let root = window.location.href.includes("apre-") ? 'https://apre-' : 'https://'
      if (this.info.isRule == 1) {
        if (this.info.isPartner == 1) {
          window.location.href = root + row.routerPartner;
        } else {
          if (row.id == 11 || row.id == 12 || row.id == 13 || row.id == 15 || row.id == 21 || row.id == 22 || row.id == 1712 || row.id == 1713) {
            window.location.href = root + row.router;
          } else {
            if (row.routerNormal != '') {
              window.location.href = root + row.routerNormal;
            } else {
              this.$refs.warning.init();
            }
          }
        }
      } else {
        if (this.info.isPartner == 1) {
          window.location.href = root + row.routerPartner;
        } else {
          if (row.routerNormal != '') {
            window.location.href = root + row.routerNormal;
          } else {
            this.$refs.warning.init();
          }
        }
      }
    },
    // 退出登录
    loginOut() {
      _tools.delCookie("QDS_COOKIE");
      _tools.delCookie("QDS_LOGIN_INFO");
      setTimeout(function () {
        return (window.location.href =
          "https://www.quandashi.com/index/logout");
      }, 300);
    }
  },
};
</script>
<style lang="less" scoped>
.head-one {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f7f7f8;
  display: flex;
  flex-direction: column;

  .head-top-box {
    width: 100%;
    height: 56px;
    display: flex;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(11, 17, 60, 0.1);

    .head-logo {
      width: 203px;
      display: flex;
      align-items: center;

      .icon-logo {
        width: 84px;
        margin-left: 50px;
        margin-right: 65px;
        margin-top: 3px;
        cursor: pointer;
      }

      .head-title {
        width: 64px;
        height: 21px;
        cursor: pointer;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #222222;
        line-height: 21px;
        margin: 0 5px 0 16px;
      }

      .version-box {
        width: 44px;
        height: 18px;
        margin-top: 3px;
        text-align: center;
        line-height: 18px;
        background: #FF6655;
        border-radius: 4px 4px 4px 0px;
        font-size: 12px;
        font-family: SourceHanSansSC-Medium, SourceHanSansSC;
        font-weight: 500;
        color: #FFFFFF;
      }
    }

    .head-con {
      flex: 1;
      display: flex;

      .tab-item {
        height: 100%;
        line-height: 56px;
        cursor: pointer;
        margin-right: 48px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #222222;

        &:hover {
          color: #ff7200;

          .item-relative {
            .trangle {
              border-bottom: 6px solid #ff7200;
            }

            .absolut-o {
              display: block;
            }

            .absolut-t {
              display: block;
            }
          }
        }

        .item-relative {
          position: relative;
          padding-right: 10px;

          .trangle {
            position: absolute;
            top: 30px;
            right: 0;
            border-bottom: 6px solid #d8d8d8;
            border-left: 6px solid transparent;
          }

          .absolut-o {
            display: none;
            position: absolute;
            top: 48px;
            left: -32px;
            background: #ffffff;
            box-shadow: 0px 0px 6px 0px rgba(11, 17, 60, 0.1);
            border-radius: 2px;
            width: 132px;
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: #222222;
            letter-spacing: 1px;
            z-index: 9;
            padding-bottom: 24px;

            .a-o-item {
              line-height: normal;
              cursor: pointer;
              margin: 24px 0 0 24px;

              &:hover {
                color: #ff7200;
              }
            }
          }

          .absolut-t {
            display: none;
            position: absolute;
            top: 48px;
            left: -32px;
            background: #ffffff;
            box-shadow: 0px 0px 6px 0px rgba(11, 17, 60, 0.1);
            border-radius: 2px;
            width: 370px;
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: #222222;
            letter-spacing: 1px;
            z-index: 9;
            padding-bottom: 24px;

            .a-t-box {
              display: flex;

              .a-t-item {
                flex: 1;

                .a-t-item-titlt {
                  display: flex;
                  align-items: center;
                  line-height: normal;
                  font-size: 14px;
                  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                  font-weight: bold;
                  color: #222222;
                  line-height: 14px;
                  letter-spacing: 1px;
                  margin: 24px 0 0 24px;
                  cursor: auto;

                  .icon-item {
                    width: 18px;
                    height: 18px;
                    margin-right: 8px;
                  }
                }

                .title-border {
                  height: 1px;
                  background: #EEEEEE;
                  margin: 8px 8px 0 24px;
                }

                .a-t-item-name {
                  line-height: normal;
                  margin: 24px 0 0 24px;
                  cursor: pointer;

                  &:hover {
                    color: #ff7200;
                  }
                }
              }
            }
          }
        }
      }
    }

    .head-user {
      display: flex;
      align-items: center;
      position: relative;
      padding-right: 5px;

      .user-name {
        padding: 0 5px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        background: url("../../assets/image/common/icon-more-arrow.png") no-repeat right bottom;
        background-size: 6px;
        overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 73px;
      }

      .user-set {
        position: absolute;
        display: none;
        background: #fff;
        top: 45px;
        left: -105px;
        z-index: 88;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 200px;
        height: auto;
        box-shadow: 0px 0px 6px 0px rgb(11 17 60 / 10%);
        border-radius: 2px;

        .user-set-item {
          cursor: pointer;
          display: flex;
          align-items: center;
          height: 28px;
          p{
            color: #333;
            font-size: 12px;
          }
          a {
            display: inline-block;
            width: 100%;
            padding-left: 60px;
            text-decoration: none;
            color: #333;
            font-size: 12px;
          }

          .icon-grzx {
            background: url("../../assets/image/common/icon-grzx.png") no-repeat 20px center;
            background-size: 16px auto;
          }

          .icon-pt {
            background: url("../../assets/image/common/icon-pt.png") no-repeat 20px center;
            background-size: 16px auto;
          }

          .icon-grxx {
            background: url("../../assets/image/common/icon-grxx.png") no-repeat 20px center;
            background-size: 16px auto;
          }

          .icon-zhaq {
            background: url("../../assets/image/common/icon-zhaq.png") no-repeat 20px center;
            background-size: 16px auto;
          }

          .icon-tcdl {
            background: url("../../assets/image/common/icon-tcdl.png") no-repeat 20px center;
            background-size: 16px auto;
          }

          img {
            width: 16px;
            height: 16px;
            margin: 0 22px;
          }
        }

        .lines {
          width: 200px;
          height: 4px;
          background: #f7f7f8;
        }
      }
    }

    .head-user:hover>.user-set {
      display: block;
    }
  }

  .content-box {
    overflow: auto;
    flex: 1;
    display: flex;
    justify-content: center;
  }
}


.active {
  color: #ff7200 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/head/head-one.vue